/* eslint-disable */
import {
  Button,
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Dropdown,
  Modal,
  message,
  Tooltip,
  Tag,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  EditOutlined,
  DeleteOutlined,
  OneToOneOutlined,
  MenuOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable } from "@/hocComponents";
import AddModal from "./component/AddModal";

export default function TypeJob() {
  const addModalRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const childRef = useRef();
  const [tableLoading, setTableLoading] = useState(false);
  const [tableList, setTableList] = useState([]);
  const [loading, setLoading] = useState(false);
  const pageSizeRef = useRef(25);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });


  // table
  const initTableHead = {
    bankGroup: null,
    remark: null,
    createByName: null,
    updateByName: null,
    active: null,
    orderField: null,
    orderType: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  // 单项删除功能
  const handleSingleDelete = (record) => {
    Modal.confirm({
      className: "commonModal",
      title: "Complete Request",
      icon: <ExclamationCircleOutlined />,
      content: <span>Are you sure to delete this item?</span>,
      okText: "Sure",
      cancelText: "Cancel",
      async onOk() {
        setLoading(true);
        try {
          const response = await http.get(api.getApModuleGlAcctDelete, {
            params: { id: record.id },
          });
          if (response.code === "1") {
            message.success("Successfully deleted.");
            getTableListFn(pagination.current, pagination.pageSize, tableHead);
          } else {
            message.error(response?.msg || "Delete failed.");
          }
        } catch (error) {
          message.error("An error occurred. Please try again.");
        } finally {
          setLoading(false);
        }
      },
      onCancel() {},
      style: {
        top: "40%",
      },
    });
  };

  // 渲染带 Tooltip 的列表
const renderListWithTooltip = (list) => {
  if (!list || list.length === 0) return '-';
  return (
    <Flex gap="4px 0" wrap="wrap" align="center" justify="center">
      {list.map((item, index) => (
     <Tooltip key={index} title={`${item.glAcct} - ${item.title}`}>
          <Tag
           color="blue"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              // maxWidth: '150px',
            }}
          >
            {item.glAcct}
          </Tag>
        </Tooltip>
      ))}
    </Flex>
  );
};

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      hidden: false,
      align: "center",
      width: 50,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("Edit") ||
          commonFn.btnAuthorityFlag("Delete")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("Edit") && {
                  key: "edit",
                  icon: (
                    <EditOutlined
                      style={{ color: "#00c0ef", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Edit </div>,
                },
                commonFn.btnAuthorityFlag("Delete") && {
                  key: "delete",
                  icon: (
                    <DeleteOutlined
                      style={{ color: "#ff4d4f", fontSize: "17px" }}
                    />
                  ),
                  label: <div>Delete </div>,
                },
              ].filter(Boolean),
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>
        ),
    },
    {
      title: "Name",
      dataIndex: "name",
      titleType: "Input",
      isSorter: true,
      width:180,
      onChange: (e) => tableFilterFn(e, "name"),
    },
    {
      title: "Code",
      dataIndex: "code",
      titleType: "Input",
      isSorter: true,
      width:120,
      onChange: (e) => tableFilterFn(e, "code"),
    },
    {
      title: "Z64 GL Accounts",
      dataIndex: "z64GlAcctList",
      width:300,
      render: (text) => renderListWithTooltip(text),
    },
    {
      title: "Gen GL Accounts",
      dataIndex: "genGlAcctList",
      width:300,
      render: (text) => renderListWithTooltip(text),
    },
    {
      title: "Status",
      dataIndex: "status",
      titleType: "Select",
      width:120,
      selectOptions: [
        { label: "All", value: "" },
        { label: "Active", value: "1" },
        { label: "Inactive", value: "0" },
      ],
      onChange: (value) => tableFilterFn(value, "status", "Select"),
      render: (text) => {
        if (text === 1 || text === "1") return "Active";
        if (text === 0 || text === "0") return "Inactive";
        return text || "-";
      },
    }
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 调用子组件showModal方法
  const showModalAdd = () => {
    addModalRef.current?.setModelAdd();
  };

  const showModalThree = () => {
    if (
      childRef.current &&
      typeof childRef.current.clearInputs === "function"
    ) {
      childRef.current.clearInputs();
      childRef.current.newListFun();
    }
  };

  const handleMenuClick = (e, record) => {
    if (e.key === "edit") {
      addModalRef.current?.setModelEdit(record);
    }
    if (e.key === "delete") {
      handleSingleDelete(record);
    }
  };

  // 处理选项变化
  const handleTableChange = (pagination, filters, sorter) => {
    pageSizeRef.current = pagination.pageSize;
    const { field: orderField, order: orderType } = sorter;
    const tableHeadTemp = {
      ...tableHead,
      orderField: orderField || "",
      orderType: orderType || "",
    };
    getTableListFn(pagination.current, pageSizeRef.current, tableHeadTemp);
  };


  const handleChange = (checkedValues) => {
    console.log(checkedValues);
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };

  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  // 获取列表数据
  const getTableListFn = async (current, pageSize, searchParams = {}) => {
    setTableLoading(true);
    try {
      const queryParams = {
        page: current || pagination.current,
        count: pageSize || pagination.pageSize,
        ...searchParams,
      };

      Object.keys(queryParams).forEach((key) => {
        if (
          queryParams[key] === null ||
          queryParams[key] === undefined ||
          queryParams[key] === ""
        ) {
          delete queryParams[key];
        }
      });

      const response = await http.get(api.getApModuleGlAcctShow, {
        params: queryParams,
      });

      if (response?.code !== "1") {
        commonFn.modalFailedFn(response);
        setTableLoading(false);
        return;
      }

      const data = response.data || {};
      const list = (data.list || []).map((item) => ({
        ...item,
        key: item.id,
      }));
      setTableList(list);

      setPagination({
        current: data.pageNum || current || 1,
        pageSize: data.pageSize || pageSize || 25,
        total: data.total || 0,
      });
    } catch (error) {
      message.error("Failed to fetch data");
    } finally {
      setTableLoading(false);
    }
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

useEffect(() => {
  initColunmsFn();
  getTableListFn(1, 25, initTableHead);
}, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          <Space size="large">
            {commonFn.btnAuthorityFlag("New") && (
              <Button className="btnNew" onClick={showModalAdd}>
                <PlusOutlined />
                New
              </Button>
            )}
          </Space>
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        tableCss="maintenanceTable"
        rowKey="id" 
      />
   <AddModal
  ref={addModalRef}
  onSuccess={() => {
    setTableHead(initTableHead);
    setRefreshKey(prev => prev + 1);
  }}
/>
    </div>
  );
}